/**
 * Progressive enhancement for the card's Add to cart.
 *
 * The form posts to /cart/add on its own, so this works with JS disabled — the
 * page just navigates to the cart. With JS, the add happens in place and the
 * button reports back, keeping the customer on the grid. cart.js makes the
 * request and announces `cart:updated`, which repaints the header badge and
 * opens the cart drawer; the card only looks after its own button.
 *
 * Delegated from document so cards injected later (the homepage parts swap)
 * are covered without re-binding.
 */
document.addEventListener('submit', async (event) => {
  const form = event.target.closest('[data-card-add]');
  if (!form) return;
  // No helper loaded: let the form post to /cart/add as it would without JS.
  if (!window.Cart) return;

  event.preventDefault();

  const button = form.querySelector('.product-card__button');
  const label = form.querySelector('[data-add-label]');
  if (button?.dataset.state === 'adding') return;

  const original = label?.textContent ?? 'Add to cart';
  if (button) button.dataset.state = 'adding';
  if (label) label.textContent = 'Adding…';

  try {
    await window.Cart.add([{
      id: Number(form.querySelector('[name="id"]').value),
      quantity: Number(form.querySelector('[name="quantity"]').value || 1),
    }]);

    if (button) button.dataset.state = 'added';
    if (label) label.textContent = 'Added ✓';

    setTimeout(() => {
      if (button) delete button.dataset.state;
      if (label) label.textContent = original;
    }, 2000);
  } catch (err) {
    console.error('[product-card]', err);
    if (button) delete button.dataset.state;
    // Surface the real reason rather than silently doing nothing.
    if (label) label.textContent = 'Unavailable';
    setTimeout(() => { if (label) label.textContent = original; }, 2500);
  }
});
